import { Filter, RefreshCw } from "lucide-react";
import { FilterConfig, ProductListConfig } from "@b2b/ui-components";

// Filters config
export const transactionFilters: FilterConfig[] = [
  {
    type: "button",
    label: "Date Range",
    icon: Filter,
    variant: "outline",
  },
  {
    type: "button",
    label: "Status",
    icon: Filter,
    variant: "outline",
  },
  {
    type: "button",
    label: "Refresh",
    icon: RefreshCw,
    variant: "outline",
  },
];

// Table config
export const transactionTableConfig: ProductListConfig = {
  columns: [
    { key: "id", label: "Transaction ID" },
    { key: "buyer", label: "Buyer" },
    { key: "seller", label: "Seller" },
    { key: "product", label: "Product" },
    { key: "amount", label: "Amount" },
    { key: "status", label: "Status" },
    { key: "paymentMethod", label: "Payment Method" },
    { key: "date", label: "Date" },
    { key: "actions", label: "Actions" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {
      completed: { background: "bg-green-100", textColor: "text-green-700" },
      pending: { background: "bg-yellow-100", textColor: "text-yellow-700" },
      processing: { background: "bg-gray-100", textColor: "text-gray-700" },
      refunded: { background: "bg-red-100", textColor: "text-red-700" },
      failed: { background: "bg-red-100", textColor: "text-red-700" },
    },
  },
};

// Mock transactions
export const mockTransactions = [
  {
    id: "TXN-2024-001247",
    buyer: "Global Industries Ltd.",
    seller: "TechCorp Inc.",
    product: "Wireless Headphones - Premium Edition",
    amount: "$2,450.00",
    status: "completed",
    date: "2024-03-15",
    paymentMethod: "Bank Transfer",
  },
  {
    id: "TXN-2024-001246",
    buyer: "Manufacturing Co.",
    seller: "Steel Works Ltd.",
    product: "Industrial Steel Pipes (500 units)",
    amount: "$12,750.00",
    status: "pending",
    date: "2024-03-14",
    paymentMethod: "Credit Card",
  },
  {
    id: "TXN-2024-001245",
    buyer: "Fashion Retail Chain",
    seller: "Organic Cotton Co.",
    product: "Cotton T-Shirts (250 units)",
    amount: "$4,875.00",
    status: "processing",
    date: "2024-03-13",
    paymentMethod: "PayPal",
  },
  {
    id: "TXN-2024-001244",
    buyer: "Electronics Store",
    seller: "Component Suppliers",
    product: "Electronic Components Bundle",
    amount: "$8,920.00",
    status: "refunded",
    date: "2024-03-12",
    paymentMethod: "Bank Transfer",
  },
];
